import { blogPost1, blogPost2, blogPost3 } from "../images";

export const blogsData: {
  img: string;
  postDate: string;
  title: string;
}[] = [
  {
    img: `${blogPost1}`,
    postDate: "October 1, 2020",
    title: "Transition Your Favorite Looks into what you need in perfect way",
  },
  {
    img: `${blogPost2}`,
    postDate: "October 2, 2022",
    title: "Meeting Breathtaking Beauty for Ev...",
  },
  {
    img: `${blogPost3}`,
    postDate: "October 2, 2021",
    title: "Perfect Quality Reasonable Price fo...",
  },
  {
    img: `${blogPost1}`,
    postDate: "October 1, 2020",
    title: "Transition Your Favorite Looks into what you need in perfect way",
  },
  {
    img: `${blogPost2}`,
    postDate: "October 2, 2022",
    title: "Meeting Breathtaking Beauty for Ev...",
  },
  {
    img: `${blogPost3}`,
    postDate: "October 2, 2021",
    title: "Perfect Quality Reasonable Price fo...",
  },
  {
    img: `${blogPost1}`,
    postDate: "October 1, 2020",
    title: "Transition Your Favorite Looks into what you need in perfect way",
  },
  {
    img: `${blogPost2}`,
    postDate: "October 2, 2022",
    title: "Meeting Breathtaking Beauty for Ev...",
  },
  {
    img: `${blogPost3}`,
    postDate: "October 2, 2021",
    title: "Perfect Quality Reasonable Price fo...",
  },
  {
    img: `${blogPost1}`,
    postDate: "October 1, 2020",
    title: "Transition Your Favorite Looks into what you need in perfect way",
  },
  {
    img: `${blogPost2}`,
    postDate: "October 2, 2022",
    title: "Meeting Breathtaking Beauty for Ev...",
  },
  {
    img: `${blogPost3}`,
    postDate: "October 2, 2021",
    title: "Perfect Quality Reasonable Price fo...",
  },
];
